// Messages for operator/ShipmentDetail (auto-merged into the i18n catalog by lib/i18n.ts).
export const en = {
  'operator.shipment_detail.head': '{shipmentNo} — Operator',
  'operator.shipment_detail.back': 'Back to shipments',
  'operator.shipment_detail.export': 'Export',
  'operator.shipment_detail.edit': 'Edit',
  'operator.shipment_detail.notify': 'Notify customer',
  'operator.shipment_detail.delete': 'Delete',
  'operator.shipment_detail.delete_aria': 'Delete shipment',
  'operator.shipment_detail.more_aria': 'More actions',
  'operator.shipment_detail.delete_confirm.title': 'Delete this shipment?',
  'operator.shipment_detail.delete_confirm.body':
    'Shipment {shipment_no} will be removed from the shipments list. It can still be recovered by a developer if needed.',
  'operator.shipment_detail.customer': 'Customer',
  'operator.shipment_detail.details': 'Shipment Details',
  'operator.shipment_detail.cargo': 'Cargo Details',
  'operator.shipment_detail.edit_cargo': 'Edit cargo',
  'operator.shipment_detail.cargo_total_weight': 'Total weight',
  'operator.shipment_detail.cargo_total_volume': 'Total volume',
  'operator.shipment_detail.spec.mbl': 'MBL',
  'operator.shipment_detail.spec.vessel': 'Vessel',
  'operator.shipment_detail.spec.hbl': 'HBL',
  'operator.shipment_detail.spec.voyage': 'Voyage',
  'operator.shipment_detail.spec.type': 'Shipment type',
  'operator.shipment_detail.spec.container_size': 'Container size',
  'operator.shipment_detail.spec.incoterm': 'Incoterm',
  'operator.shipment_detail.spec.weight': 'Gross weight',
  'operator.shipment_detail.spec.loading_port': 'Loading port',
  'operator.shipment_detail.spec.discharge_port': 'Discharge port',
  'operator.shipment_detail.spec.origin': 'Origin location',
  'operator.shipment_detail.spec.final_destination': 'Final destination',
  'operator.shipment_detail.spec.etc': 'ETC',
  'operator.shipment_detail.spec.ata': 'ATA date',
  'operator.shipment_detail.spec.etd': 'ETD',
  'operator.shipment_detail.spec.final_delivery': 'Final delivery date',
  'operator.shipment_detail.spec.eta_port': 'ETA to port',
  'operator.shipment_detail.spec.eta_final': 'ETA to final destination',
  'operator.shipment_detail.spec.pos': 'Purchase orders',
  'operator.shipment_detail.no_pos': 'No purchase orders',
  'operator.shipment_detail.customer_no_contact': 'No contact details on file',
  'operator.shipment_detail.tab.messages': 'Messages',
  'operator.shipment_detail.tab.documents': 'Documents',
  'operator.shipment_detail.tab.packages': 'Packages',
  'operator.shipment_detail.tab.quote': 'Quote',
  'operator.shipment_detail.tracking': 'Tracking',
  'operator.shipment_detail.bulk_edit': 'Bulk edit',
  'operator.shipment_detail.no_legs': 'No legs recorded yet.',
  'operator.shipment_detail.add_leg': 'Add leg',
  'operator.shipment_detail.update_status': 'Update status',
  'operator.shipment_detail.confirm_remove_leg': 'Remove this leg?',
  'operator.shipment_detail.confirm_remove_doc': 'Remove this document?',
  'operator.shipment_detail.leg.edit_aria': 'Edit leg',
  'operator.shipment_detail.leg.remove_aria': 'Remove leg',
  'operator.shipment_detail.leg.toggle_complete_aria': 'Toggle leg completed',
  'operator.shipment_detail.leg.mark_complete': 'Mark completed',
  'operator.shipment_detail.leg.completed': 'Completed — click to undo',
  'operator.shipment_detail.leg.atd': 'ATD',
  'operator.shipment_detail.leg.eta': 'ETA',
  'operator.shipment_detail.leg.ata': 'ATA',
  'operator.shipment_detail.messages.empty': 'No messages yet.',
  'operator.shipment_detail.messages.aria': 'Message',
  'operator.shipment_detail.messages.internal_placeholder': 'Internal note…',
  'operator.shipment_detail.messages.placeholder': 'Message…',
  'operator.shipment_detail.messages.customer': 'Customer message',
  'operator.shipment_detail.messages.internal': 'Internal note',
  'operator.shipment_detail.messages.send': 'Send',
  'operator.shipment_detail.docs.all': 'All documents (internal + shared)',
  'operator.shipment_detail.docs.upload': 'Upload',
  'operator.shipment_detail.docs.empty': 'No documents.',
  'operator.shipment_detail.docs.internal': 'Internal',
  'operator.shipment_detail.docs.download_aria': 'Download {title}',
  'operator.shipment_detail.docs.edit_aria': 'Edit {title}',
  'operator.shipment_detail.docs.remove_aria': 'Remove {title}',
  'operator.shipment_detail.packages.empty': 'No packages recorded.',
  'operator.shipment_detail.packages.col.container': 'Container',
  'operator.shipment_detail.packages.col.type': 'Type',
  'operator.shipment_detail.packages.col.weight': 'Weight',
  'operator.shipment_detail.packages.col.cbm': 'CBM',
  'operator.shipment_detail.packages.col.parcels': 'Parcels',
  'operator.shipment_detail.packages.col.loose_parcel': 'Loose parcel',
  'operator.shipment_detail.packages.col.tracking': 'Tracking',
  'operator.shipment_detail.quote.empty': 'No quote attached.',
  'operator.shipment_detail.quote.create': 'Create quote',
  'operator.shipment_detail.quote.linked': 'View quote',
  'operator.shipment_detail.quote.note':
    'Operator view shows cost & margin — never sent to the customer portal.',
  'operator.shipment_detail.quote.col.item': 'Item',
  'operator.shipment_detail.quote.col.cost': 'Cost',
  'operator.shipment_detail.quote.col.sell': 'Sell',
  'operator.shipment_detail.quote.col.margin': 'Margin',
}

export const zhTW = {
  'operator.shipment_detail.head': '{shipmentNo} — 操作端',
  'operator.shipment_detail.back': '返回貨件列表',
  'operator.shipment_detail.export': '匯出',
  'operator.shipment_detail.edit': '編輯',
  'operator.shipment_detail.notify': '通知客戶',
  'operator.shipment_detail.delete': '刪除',
  'operator.shipment_detail.delete_aria': '刪除貨件',
  'operator.shipment_detail.more_aria': '更多操作',
  'operator.shipment_detail.delete_confirm.title': '刪除這筆貨件？',
  'operator.shipment_detail.delete_confirm.body':
    '貨件 {shipment_no} 將從貨件列表中移除。如有需要，仍可由開發人員復原。',
  'operator.shipment_detail.customer': '客戶',
  'operator.shipment_detail.details': '貨件明細',
  'operator.shipment_detail.cargo': '貨物明細',
  'operator.shipment_detail.edit_cargo': '編輯貨物',
  'operator.shipment_detail.cargo_total_weight': '總重量',
  'operator.shipment_detail.cargo_total_volume': '總體積',
  'operator.shipment_detail.spec.mbl': 'MBL',
  'operator.shipment_detail.spec.vessel': '船名',
  'operator.shipment_detail.spec.hbl': 'HBL',
  'operator.shipment_detail.spec.voyage': '航次',
  'operator.shipment_detail.spec.type': '運輸類型',
  'operator.shipment_detail.spec.container_size': '貨櫃類型',
  'operator.shipment_detail.spec.incoterm': '貿易條件',
  'operator.shipment_detail.spec.weight': '毛重',
  'operator.shipment_detail.spec.loading_port': '裝貨港',
  'operator.shipment_detail.spec.discharge_port': '卸貨港',
  'operator.shipment_detail.spec.origin': '起運地',
  'operator.shipment_detail.spec.final_destination': '最終目的地',
  'operator.shipment_detail.spec.etc': 'ETC',
  'operator.shipment_detail.spec.ata': 'ATA 日期',
  'operator.shipment_detail.spec.etd': 'ETD',
  'operator.shipment_detail.spec.final_delivery': '最終送達日期',
  'operator.shipment_detail.spec.eta_port': '預計到港',
  'operator.shipment_detail.spec.eta_final': '預計到達最終目的地',
  'operator.shipment_detail.spec.pos': '採購單',
  'operator.shipment_detail.no_pos': '尚無採購單',
  'operator.shipment_detail.customer_no_contact': '尚無聯絡資訊',
  'operator.shipment_detail.tab.messages': '訊息',
  'operator.shipment_detail.tab.documents': '文件',
  'operator.shipment_detail.tab.packages': '貨物',
  'operator.shipment_detail.tab.quote': '報價',
  'operator.shipment_detail.tracking': '追蹤',
  'operator.shipment_detail.bulk_edit': '批次編輯',
  'operator.shipment_detail.no_legs': '尚未記錄任何航段。',
  'operator.shipment_detail.add_leg': '新增航段',
  'operator.shipment_detail.update_status': '更新狀態',
  'operator.shipment_detail.confirm_remove_leg': '要移除此航段嗎？',
  'operator.shipment_detail.confirm_remove_doc': '要移除此文件嗎？',
  'operator.shipment_detail.leg.edit_aria': '編輯航段',
  'operator.shipment_detail.leg.remove_aria': '移除航段',
  'operator.shipment_detail.leg.toggle_complete_aria': '切換航段完成狀態',
  'operator.shipment_detail.leg.mark_complete': '標記為完成',
  'operator.shipment_detail.leg.completed': '已完成 — 點擊以取消',
  'operator.shipment_detail.leg.atd': '實際出發',
  'operator.shipment_detail.leg.eta': '預計到達',
  'operator.shipment_detail.leg.ata': '實際到達',
  'operator.shipment_detail.messages.empty': '尚無訊息。',
  'operator.shipment_detail.messages.aria': '訊息',
  'operator.shipment_detail.messages.internal_placeholder': '內部備註…',
  'operator.shipment_detail.messages.placeholder': '訊息…',
  'operator.shipment_detail.messages.customer': '客戶訊息',
  'operator.shipment_detail.messages.internal': '內部備註',
  'operator.shipment_detail.messages.send': '傳送',
  'operator.shipment_detail.docs.all': '所有文件（內部 + 共享）',
  'operator.shipment_detail.docs.upload': '上傳',
  'operator.shipment_detail.docs.empty': '尚無文件。',
  'operator.shipment_detail.docs.internal': '內部',
  'operator.shipment_detail.docs.download_aria': '下載 {title}',
  'operator.shipment_detail.docs.edit_aria': '編輯 {title}',
  'operator.shipment_detail.docs.remove_aria': '移除 {title}',
  'operator.shipment_detail.packages.empty': '尚未記錄任何貨物。',
  'operator.shipment_detail.packages.col.container': '貨櫃',
  'operator.shipment_detail.packages.col.type': '類型',
  'operator.shipment_detail.packages.col.weight': '重量',
  'operator.shipment_detail.packages.col.cbm': '材積（CBM）',
  'operator.shipment_detail.packages.col.parcels': '包裹數',
  'operator.shipment_detail.packages.col.loose_parcel': '散裝包裹',
  'operator.shipment_detail.packages.col.tracking': '追蹤號碼',
  'operator.shipment_detail.quote.empty': '尚未附加報價。',
  'operator.shipment_detail.quote.create': '建立報價',
  'operator.shipment_detail.quote.linked': '檢視報價',
  'operator.shipment_detail.quote.note': '操作端檢視顯示成本與毛利 — 絕不會傳送至客戶入口。',
  'operator.shipment_detail.quote.col.item': '項目',
  'operator.shipment_detail.quote.col.cost': '成本',
  'operator.shipment_detail.quote.col.sell': '售價',
  'operator.shipment_detail.quote.col.margin': '毛利',
}
